<template>
  <LoadingSpinner v-if="loading" />
  <WidgetSigned
    v-else-if="enabled"
    :widgetCode="widgetCode"
  />
  <EnvelopeComplete
    v-else
    status="verify"
  />
</template>

<script setup>
// @ts-check
import { defineProps } from 'vue'
import { useFlagEnabled } from '@/composables/useFlagEnabled'

import LoadingSpinner from '@/components/LoadingSpinner.vue'
import EnvelopeComplete from '@/views/EnvelopeComplete.vue'
import WidgetSigned from '@/views/WidgetSigned.vue'

defineProps({
  widgetCode: {
    type: String,
    required: true
  }
})

const [loading, enabled] = useFlagEnabled('moooore-branding')
</script>
